import heroGlow from '../../assets/hero-glow.jpg'
import { GOALS, reachGoal } from '../../lib/metrika'

// Тёмный герой по референсу Mappetplace.
//
// Приём, ради которого он и взят: свет расходится кольцами из одной точки,
// и в этой точке стоит кнопка. Она перестаёт быть элементом в углу и
// становится смысловым центром экрана.
//
// Свечение — готовая картинка, а не css-градиенты. Рисованные кольца давали
// видимые ступени и читались как плоские диски; здесь переход гладкий,
// с мягкими кромками, которых стопами в radial-gradient не набрать.

export function Hero() {
  return (
    <section id="hero" className="px-4 sm:px-6 lg:px-5">
      <div className="relative mx-auto max-w-[1920px] overflow-hidden rounded-[20px] bg-[#02061a] sm:rounded-[24px] lg:rounded-[30px]">
        {/* Мобильный ореол — градиент, а не картинка.
            Десктопную сюда не поставить: её ядро сидит у правого края и по
            краям она не гаснет, поэтому на узком экране, где слой меньше
            карточки, её прямоугольник проступал рамкой. Пересобранная копия
            (поле из зеркальных отражений плюс виньетка) рамку убирала, но
            давала тёмные пятна: отражения накладываются кольцами друг на
            друга, и получалась интерференция.
            Градиент свободен от обоих дефектов — он гладкий по определению
            и не имеет краёв. Тона сняты пипеткой с десктопной картинки,
            чтобы мобилка не разошлась с ней по цвету. */}
        <div
          aria-hidden
          className="pointer-events-none absolute left-1/2 top-[88%] size-[640px] -translate-x-1/2 -translate-y-1/2 sm:top-[86%] sm:size-[780px] lg:hidden"
          style={{
            backgroundImage:
              'radial-gradient(circle at center, #0046fd 0%, #003ffc 12%, #0031e3 24%,' +
              ' #0223b0 38%, #00187f 52%, rgba(0,12,70,0.42) 66%, rgba(2,6,26,0) 84%)',
          }}
        />

        {/* Свечение — отдельный слой, а не background карточки: фоном ядро
            картинки к кнопке не подвести, потому что проценты в
            background-position совмещают точку P% картинки с точкой P%
            контейнера. У слоя же `translate` считается от его собственного
            размера, и им ядро подводится куда угодно.
            Смещение подобрано по картинке: -80% по X, -62% по Y. */}
        <div
          aria-hidden
          className="pointer-events-none absolute left-[78%] top-[73%] hidden w-[132%] max-w-none lg:block"
          style={{
            aspectRatio: '1672 / 941',
            backgroundImage: `url(${heroGlow})`,
            backgroundSize: '100% 100%',
            transform: 'translate(-80%, -62%)',
          }}
        />
        <div className="relative mx-auto flex max-w-[1400px] flex-col px-4 pt-24 pb-0 sm:px-6 sm:pt-28 lg:min-h-[680px] lg:justify-center lg:px-10 lg:py-28">
          {/* На узких вся колонка центрируется — так в референсе мобильной
              композиции. С lg возвращается выключка влево: там справа стоит
              кнопка в свечении, и текст должен держать левый край. */}
          <div className="text-center lg:max-w-[620px] lg:text-left">
            <span
              className="font-body inline-flex items-center gap-2 rounded-full border border-white/20 bg-[#030b1c]/70 px-3.5 py-1.5 text-[13px] leading-5 text-white backdrop-blur-sm sm:text-[14px]"
              style={{ opacity: 0, animation: 'fadeUp 0.7s ease-out 0.15s forwards' }}
            >
              <span className="size-1.5 rounded-full bg-[#7fb0ff]" aria-hidden />
              Бюджет кампании от&nbsp;10&nbsp;000&nbsp;₽
            </span>

            {/* Начертание светлое, полужирный — только на выделенной части.
                В референсе так же: тонкий заголовок и один акцент, за счёт
                этого фраза читается на одном дыхании. */}
            <h1
              className="mt-6 font-sans font-light text-white sm:mt-7 lg:mt-9"
              style={{ fontSize: 'clamp(34px, 4.4vw, 62px)', lineHeight: 1.12, letterSpacing: '-0.02em' }}
            >
              <span
                className="inline sm:block"
                style={{ opacity: 0, animation: 'fadeUp 0.7s ease-out 0.3s forwards' }}
              >
                Находите новых клиентов
              </span>{' '}
              <span
                className="inline sm:mt-1 sm:block"
                style={{ opacity: 0, animation: 'fadeUp 0.7s ease-out 0.5s forwards' }}
              >
                для <Highlight>вашего бизнеса</Highlight>
              </span>
            </h1>

            <p
              className="font-body mx-auto mt-6 max-w-[540px] text-[17px] lg:mx-0 leading-[1.6] tracking-[-0.1px] text-[#e2ebfd] sm:mt-7 sm:text-[19px] lg:text-[20px]"
              style={{ opacity: 0, animation: 'fadeUp 0.7s ease-out 0.7s forwards' }}
            >
              Разместите свои предложения на&nbsp;витрине{' '}
              <a
                href="https://ris.promo/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => reachGoal(GOALS.showcaseClick, { place: 'герой' })}
                className="text-[#a8c8ff] underline decoration-from-font underline-offset-2 transition-colors hover:text-white"
              >
                RIS.Promo
              </a>
              . Настраивайте рекламу и&nbsp;собирайте лиды в&nbsp;личном кабинете
              без&nbsp;менеджеров и&nbsp;рутины.
            </p>
          </div>
        </div>

        {/* Кнопка — прямой ребёнок карточки, а не колонки с текстом: 78%/73%
            считаются от карточки, иначе привязка поплыла бы от внутренних
            отступов сетки. 73% по вертикали — это центр абзаца слева, так
            кнопка и свечение встают на одну линию с текстом, как в референсе.
            Те же координаты стоят у слоя свечения выше — двигать их парой.
            На узких экранах кнопка возвращается в поток под текст, где
            абсолютное позиционирование только мешало бы. */}
        <div
          className="relative flex justify-center px-4 pt-10 pb-16 sm:px-6 sm:pb-20 lg:absolute lg:block lg:top-[73%] lg:left-[78%] lg:z-10 lg:-translate-x-1/2 lg:-translate-y-1/2 lg:p-0"
          style={{ opacity: 0, animation: 'fadeUp 0.7s ease-out 0.9s forwards' }}
        >
          <a
            href="https://lk.ris.promo/auth/register"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => reachGoal(GOALS.signupClick, { place: 'герой' })}
            className="inline-flex items-center justify-center rounded-full bg-white px-9 py-4 font-sans text-[17px] font-medium leading-7 tracking-[-0.2px] text-[#041527] transition duration-300 ease-out hover:bg-[#eef3ff] active:bg-[#dfe8ff] sm:text-[18px]"
            style={{ boxShadow: '0 18px 44px -12px rgba(2,10,40,0.8)' }}
          >
            Создать аккаунт
          </a>
        </div>
      </div>
    </section>
  )
}

// Боковой выступ плашки. Пробел в заголовке — 0.237em, поэтому больше 0.22em
// брать нельзя: плашка заедет под букву предыдущего слова и слипнется с ним.
const HL_SIDE = '-0.2em'

/**
 * Подсветка слова — ровная плашка со скруглением по всем углам.
 * Курсор-линия справа убрана: она делала выделение асимметричным, текст
 * прижимался к правому краю, и приём читался как незавершённый.
 */
function Highlight({ children }: { children: React.ReactNode }) {
  return (
    <span className="relative inline-block whitespace-nowrap font-semibold text-white">
      <span
        aria-hidden
        style={{
          position: 'absolute',
          top: '0.02em',
          bottom: '0.02em',
          left: HL_SIDE,
          right: HL_SIDE,
          backgroundImage: 'linear-gradient(rgba(120,170,255,0.42), rgba(120,170,255,0.42))',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '0% 100%',
          backgroundPosition: 'left center',
          borderRadius: '0.18em',
          animation: 'selectSweep 0.5s cubic-bezier(0.45, 0, 0.15, 1) 1.0s forwards',
          zIndex: 0,
        }}
      />
      <span className="relative" style={{ zIndex: 1 }}>{children}</span>
    </span>
  )
}
